(function(){
if(!window.THREE||!window.SH)return;
var canvas=document.getElementById('alema-canvas'),hero=document.getElementById('hero');if(!canvas||!hero)return;
var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches,renderer;
try{renderer=new THREE.WebGLRenderer({canvas:canvas,alpha:true,antialias:true})}catch(e){return}
renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,2));
var scene=new THREE.Scene(),cam=new THREE.PerspectiveCamera(40,1,.1,50);cam.position.z=6;
var K=3.2/1000;
function sm(p){var q=[],n=p.length;for(var i=0;i<n;i++){var a=p[i],b=p[(i+1)%n];q.push(new THREE.Vector2(a.x*.75+b.x*.25,a.y*.75+b.y*.25),new THREE.Vector2(a.x*.25+b.x*.75,a.y*.25+b.y*.75))}return q}
function pts(f){var p=[];for(var i=0;i<f.length;i+=2)p.push(new THREE.Vector2(f[i]*K,f[i+1]*K));return sm(p)}
var shape=new THREE.Shape(pts(SH[0]));
for(var h=1;h<SH.length;h++)shape.holes.push(new THREE.Path(pts(SH[h])));
var geo=new THREE.ExtrudeGeometry(shape,{depth:.2,bevelEnabled:true,bevelThickness:.035,bevelSize:.02,bevelSegments:5,curveSegments:1});
geo.translate(0,0,-.1);
var mat=new THREE.MeshStandardMaterial({color:0x0b2a5c,metalness:.35,roughness:.3});
if(hero.dataset.logo){mat.color.set(hero.dataset.logo);mat.metalness=.1;mat.roughness=.45}
var logo=new THREE.Mesh(geo,mat);scene.add(logo);
scene.add(new THREE.AmbientLight(0xffffff,.65));
var k=new THREE.DirectionalLight(0xffffff,1.1);k.position.set(-3,4,5);scene.add(k);
var r=new THREE.PointLight(0x8fb2ff,1.6,30);r.position.set(4,-2,3);scene.add(r);
var vis=true;if('IntersectionObserver' in window)new IntersectionObserver(function(en){vis=en[0].isIntersecting}).observe(hero);
var drag=false,lx=0,ly=0,rx=0,ry=0,vx=0,vy=0,mx=0,my=0,sx=0,sy=0,TAU=Math.PI*2;
hero.addEventListener('pointerdown',function(e){if(e.target.closest('a'))return;drag=true;lx=e.clientX;ly=e.clientY;hero.classList.add('drag');try{hero.setPointerCapture(e.pointerId)}catch(_){}});
hero.addEventListener('pointermove',function(e){if(!drag)return;vy=(e.clientX-lx)*.008;vx=(e.clientY-ly)*.008;ry+=vy;rx+=vx;lx=e.clientX;ly=e.clientY});
function up(){drag=false;hero.classList.remove('drag')}
hero.addEventListener('pointerup',up);hero.addEventListener('pointercancel',up);
addEventListener('pointermove',function(e){if(!reduce&&!drag){mx=e.clientX/innerWidth-.5;my=e.clientY/innerHeight-.5}});
function size(){var w=canvas.clientWidth,h=canvas.clientHeight;if(!w||!h)return;renderer.setSize(w,h,false);cam.aspect=w/h;cam.updateProjectionMatrix()}
if('ResizeObserver' in window)new ResizeObserver(size).observe(canvas);addEventListener('resize',size);size();
function frame(ms){
requestAnimationFrame(frame);if(!vis)return;
var t=reduce?0:ms/1000,visH=2*Math.tan(cam.fov*Math.PI/360)*cam.position.z,visW=visH*cam.aspect,wide=cam.aspect>1;
if(!drag){ry+=vy;rx+=vx;vy*=.94;vx*=.94;ry+=(Math.round(ry/TAU)*TAU-ry)*.02;rx+=(0-rx)*.03}
sx+=(mx-sx)*.06;sy+=(my-sy)*.06;
logo.scale.setScalar((wide?Math.min(visW*.4,3.6):visW*.8)/3.2);
logo.position.set(0,visH*.08+Math.sin(t*1.1)*.08,0);
logo.rotation.y=ry+sx*.7+Math.sin(t*.6)*.22;
logo.rotation.x=rx+sy*.5+Math.sin(t*.8)*.06;
renderer.render(scene,cam)}
requestAnimationFrame(frame);
})();
